var inline_video = $('.related-videos').length == 0;
if (inline_video) $('body').append('<div class="video-scroll-viewport" />');

$('.grid-one-inner').each(function () {
    var $item = $(this);
    var $parent = $item.parents('.grid-one');
    var $img = $item.find('img');
    var video_type = $img.attr('data-videotype') || false;
    var video_src = $img.attr('data-videosrc') || false;

    //if video available
    if (video_type && video_src) {
        $item.append('<span class="video-avialable" /><span class="video-progress" />');

        var $video;
        var playing = false;
        var loaded = false;
        var $flag = $item.find('.video-avialable');

        var load = function () {//add and load video, its happening one time
            $img.after('<video loop muted playsinline>' +
                '<source src="' + video_src + '" type="' + video_type + '">' +
                '</video>');
            $video = $parent.find('video');
            loaded = true;
            $video
                .on('play', function () {
                    playing = true;
                })
                .on('pause', function () {
                    playing = false;
                })
                .on('canplaythrough', function () {
                    play();
                });
        };

        var play = function () {//play video
            $video.get(0).playbackRate = 1.2;
            $video.get(0).play();
        };

        var stop = function () {//stop playing video
            $video.get(0).pause();
        };


        $item//events
            .on('mouseenter', function () {
                if ($flag.is(':visible')||$item.parents('.owl-item').length) return false;
                if (loaded) play(); else load();
            })
            .on('mouseleave', function () {
                if ($flag.is(':visible')||$item.parents('.owl-item').length) return false;
                if (playing) stop();
            });
        //video preview on mobile devices only on the main page
        if (inline_video) {
            var $viewport = $('.video-scroll-viewport');
            var viewport_y, viewport_h, item_y, item_h, y, viewport_in;
            var load_timer = false;
            var inline_avialable = false;
            var resetTimer = function () {
                clearTimeout(load_timer);
                load_timer = false;
            };
            var inline_play = function () {//play inline video
                if ($item.parents('.owl-item').length) return false;
                if (playing) stop();
                if (loaded) {
                    $parent.addClass('play--inline');
                    play();
                } else {
                    if (!load_timer) {//delay .4s
                        load_timer = setTimeout(function () {
                            $parent.addClass('play--inline');
                            resetTimer();
                            load();
                        }, 400);
                    }
                }
            };
            var inline_stop = function () {//stop inline video
                if ($item.parents('.owl-item').length) return false;
                $parent.removeClass('play--inline');
                if (load_timer) resetTimer();
                if (playing) stop();
                if ($video) $video.remove();
                loaded = false;
            };
            var resize = function () {
                inline_avialable = $viewport.is(':visible');
                if (inline_avialable) {
                    item_y = $parent.offset().top;
                    item_h = $parent.height();
                    viewport_y = $viewport.position().top;
                    viewport_h = $viewport.height();
                }
            };
            var scroll = function () {
                if (inline_avialable) {
                    y = $(window).scrollTop();
                    viewport_in = y + viewport_y + viewport_h - item_h;
                    if (viewport_in < item_y || viewport_in >= item_y + item_h) inline_stop(); else inline_play();
                }
            };
            resize();
            scroll();
            $(window)
                .on('resize', function () {
                    resize();
                })
                .on('scroll', function () {
                    scroll();
                });
        }

    }
});